import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./Plan.css";
import axios from 'axios'

function Plan() {
  const [activeTab, setActiveTab] = useState("Standard");
  const [plans, setPlans] = useState([]);


  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const response = await axios.get(
          "https://qflyers.minipossystem.com/api/v1/register-data"
        );
        console.log({ plans: response.data.plan });
        setPlans(response.data.plan || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPlan();
  }, []);
  const handleNavigateAdmin = () => {
    window.open("https://admin.qflyers.com/", "_blank", "noopener,noreferrer");
  };
  return (
    <div>
      <Header />
      <div className="plan-cont ">
        <div className="plan-main-cont container">
          <h1>
            Flexible Payment Plans for
            <br /> Your Convenience
          </h1>
          <div className="container mt-5 mb-5">
            <ul class="Payment-features d-flex justify-content space-between">
              <li>
                <span class="Payment-icon">✔</span> No Hidden changes
              </li>
              <li>
                <span class="Payment-icon">✔</span> Straightforward pricing
              </li>
              <li>
                <span class="Payment-icon">✔</span> Cancel anytime
              </li>
            </ul>
          </div>
        </div>
        <div className="">
          {/* <>
            <div className="tab-container">
              <div className="tab-view">
                {["Standard", "Premium"].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`tab-button ${activeTab === tab ? "active-tab" : ""
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>
          </> */}

          <div>

            <div>
              <div class="pricing-container container">
                {plans && plans.map((plan, index) => (
                  <div className={`plan-card ${plan.name === "Yearly" ? 'featured' : ''}`} data-aos="zoom-in-right" key={index}>
                    {plan.name === "Yearly" && (
                      <div className="ribbon">Popular</div>
                    )}

                    <div class="plan-header">
                      <h2>{plan.name}</h2>
                      <p>
                        {plan.description}
                      </p>
                    </div>
                    <hr />
                    <div class="plan-price">
                      <div
                        className="d-flex"
                        style={{ alignItems: "baseline", gap: "5px" }}
                      >
                        <h1>₹{Math.floor(plan.price)}</h1>

                        <p>Tax Included</p>
                      </div>

                      <p>{plan.get_duration_display}</p>
                      <hr />
                    </div>
                    <ul class="plan-features">
                      {plan.content.map((contents, index) => (
                        <li key={index}>
                          <span class="check-icon">✔</span> {contents.name}
                        </li>
                      ))}


                    </ul>
                    <button className={`plan-button ${plan.name === "Yearly" ? 'featured-button' : ''}`} onClick={handleNavigateAdmin}>
                      Start free 30-day Trial
                    </button>
                  </div>
                ))}



              </div>
            </div>

          </div>
          <div class="Trusted-container container">
            <h1>Trusted by <span style={{ color: "#f04b3d" }}>50K Owners</span></h1>
            <p>
              Join a community of over 50,000 satisfied owners who trust us for
              quality, reliability, and exceptional service. Our commitment to
              excellence has made us a preferred choice for individuals and
              businesses alike. By choosing us, you gain more than a service
              provider—you become part of a network that values support,
              innovation, and seamless solutions. We prioritize your success,
              standing by you every step of the way to ensure a smooth and
              rewarding experience. Whether you're starting out or seeking
              continued support, we’re here to help you achieve your goals with
              confidence.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Plan;
